import { Commission } from './commission';
import { Direction } from './direction';
import { Gateway } from './gateway';
import { Merchant } from './merchant';
import { MerchantAccount } from './merchantAccount';
import { Method } from './method';

export type Badge = {
  '@id': string;
  description: string;
  name: string;
  value: string;
};

export type ConditionGroup = {
  '@id': string;
  id: string;
  children: ConditionGroup[];
  parent?: null | string;
  isAnd: boolean;
  createdAt: string;
  expressions: Expression[];
};

export type Expression = {
  '@id': string;
  id: string;
  value: string[] | number[];
  comparisonOperator: ComparisonOperator;
  expressionParam: ExpressionParam;
};

export enum ExpressionParamFieldType {
  MultiSelect = 'multiple_select',
  Input = 'input',
}

export type ExpressionParam = {
  '@id': string;
  alias: string;
  fieldType: string;
  id: string;
  name: string;
};

export type ExpressionParamWithDataSelectItem = {
  id: number;
  name: string;
  value: string;
  active?: boolean;
};

export type ExpressionParamWithData = {
  id: number;
  name: string;
  fieldType: string;
  alias: string;
  comparisonOperators: ComparisonOperator[];
  data: ExpressionParamWithDataSelectItem[];
};

export type ComparisonOperator = {
  '@id': string;
  id: string;
  name: string;
  alias: string;
  description: string;
};

export type MappingItem = {
  '@id': string;
  id: string;
  value: number;
  merchantAccount: Partial<MerchantAccount>;
  commissions: Partial<Commission>[];
  gateway: Partial<Gateway>;
  mapping: Partial<Mapping>;
  badge: Partial<Badge> | null;
  subagent: number | null;
};

export type Mapping = {
  id: string;
  '@id': string;
  name: string;
  method: Partial<Method>;
  gatewayRule: Partial<GatewayRule>;
  originId: string;
  active: boolean;
  direction: Direction;
  mappingItems: Partial<MappingItem>[];
  description: string;
  merchantLabel: string | null;
  payoutRouting: boolean;
  sortOrder: number;
};

export type GatewayRule = {
  id: string;
  '@id': string;
  originId?: string;
  active: boolean;
  conditionGroup: ConditionGroup;
  merchant: Merchant;
  name: string;
  updatedAt: string;
  createdAt: string;
  mappings: Mapping[];
};
